import React from "react";
import { Chip } from "@mui/material";
import { getBadgeStyles } from "../../../../components/ui/badgeColors";
import { ETIQUETAS_ESTADO } from "../../constants";

/**
 * Badge de estado de una lista de inventario (PENDIENTE/EN_CURSO/COMPLETADO/
 * REVISADO), con la etiqueta y el color de ETIQUETAS_ESTADO (constants.js).
 *
 * DECISION: se adelanta desde TASK-015 (MI4, que además define
 * DiferenciaBadge) porque es una dependencia dura de las columnas y de la
 * vista móvil del listado admin (TASK-007/TASK-008, MI2): sin badge de
 * estado no hay forma de mostrar PENDIENTE/EN_CURSO/COMPLETADO/REVISADO en
 * la tabla. DiferenciaBadge, que sí depende del cálculo de diferencias
 * (helpers/transformers.js) usado en el modo resultado, queda para TASK-015
 * junto con los tests de ambos badges.
 *
 * Puro y sin estado propio: se repite por fila/tarjeta en listas
 * potencialmente largas, de ahí React.memo.
 */
const EstadoInventarioBadge = React.memo(({ estado }) => {
    const { label, color } = ETIQUETAS_ESTADO[estado] || ETIQUETAS_ESTADO.PENDIENTE;

    return <Chip label={label} size="small" sx={getBadgeStyles(color)} />;
});

EstadoInventarioBadge.displayName = "EstadoInventarioBadge";

export default EstadoInventarioBadge;
